/**
 * Pick & Mix toast — minimal one-at-a-time queue.
 * API: window.PickMixToast.show(message, opts)
 *   opts.onClick   – function fired on toast click (toast also dismisses)
 *   opts.duration  – ms before auto-dismiss (default 4500)
 *   opts.ariaLabel – optional aria-label (defaults to message)
 */
(function () {
  'use strict';

  var ENTER_MS = 300;     // matches CSS transition duration
  var DEFAULT_MS = 4500;

  var activeToast = null;
  var activeTimeoutId = null;

  function getContainer() {
    return document.querySelector('[data-toast-container]');
  }

  function buildToast(message, opts) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pickmix__toast';
    btn.setAttribute('data-toast', '');
    if (typeof opts.onClick !== 'function') btn.classList.add('pickmix__toast--informational');
    if (opts.ariaLabel) btn.setAttribute('aria-label', opts.ariaLabel);

    var msgSpan = document.createElement('span');
    msgSpan.className = 'pickmix__toast-msg';
    msgSpan.textContent = message;
    btn.appendChild(msgSpan);

    // Only show the action arrow when the toast actually does something.
    // Informational toasts (no onClick) read as static status messages.
    if (typeof opts.onClick === 'function') {
      var arrow = document.createElement('span');
      arrow.className = 'pickmix__toast-arrow';
      arrow.setAttribute('aria-hidden', 'true');
      arrow.textContent = '→';
      btn.appendChild(arrow);
    }

    return btn;
  }

  function dismiss() {
    if (!activeToast) return;
    var t = activeToast;
    activeToast = null;
    if (activeTimeoutId) {
      clearTimeout(activeTimeoutId);
      activeTimeoutId = null;
    }
    t.classList.remove('is-visible');
    setTimeout(function () {
      if (t.parentNode) t.parentNode.removeChild(t);
    }, ENTER_MS);
  }

  function show(message, opts) {
    opts = opts || {};
    var container = getContainer();
    if (!container) return;

    // Replace any existing toast immediately (no overlap)
    if (activeToast) {
      if (activeTimeoutId) clearTimeout(activeTimeoutId);
      if (activeToast.parentNode) activeToast.parentNode.removeChild(activeToast);
      activeToast = null;
    }

    var toast = buildToast(message, opts);
    container.appendChild(toast);
    activeToast = toast;

    toast.addEventListener('click', function () {
      try { if (typeof opts.onClick === 'function') opts.onClick(); }
      catch (e) { console.error('[pickmix-toast] onClick threw', e); }
      dismiss();
    });

    // Force reflow then add visible class so transition fires
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    var ms = typeof opts.duration === 'number' ? opts.duration : DEFAULT_MS;
    activeTimeoutId = setTimeout(dismiss, ms);

    return { dismiss: dismiss };
  }

  window.PickMixToast = { show: show, dismiss: dismiss };
})();
